export interface Task {
  id: string
  title: string
  notes: string | null
  url: string | null
  category: string | null
  estimatedMinutes: number | null
  sourceId: string | null
  sourceContentId: string | null
  contentBody: string | null
  source: { id: string; name: string; icon: string | null } | null
  sourceContent: { id: string; title: string } | null
  createdAt: string
  updatedAt: string
}

export interface TaskFormData {
  title: string
  notes: string
  url: string
  category: string
  estimatedMinutes: number | null
  sourceId: string | null
  sourceContentId: string | null
  contentBody: string
}

export const TASK_CATEGORIES = [
  { value: 'reading', label: 'Reading' },
  { value: 'practice', label: 'Practice' },
  { value: 'setup', label: 'Setup' },
  { value: 'review', label: 'Review' },
  { value: 'project', label: 'Project' },
  { value: 'other', label: 'Other' },
] as const

export type TaskCategory = (typeof TASK_CATEGORIES)[number]['value']
